var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _g, _path54, _g2, _path55, _path56, _g3, _path57;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCenterImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 131 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.858 25.515l-9.402 7.557-5.653-9.796a10.375 10.375 0 00-6.157-4.814c-.951-.28-1.903-.448-2.91-.448H78.02h.783l1.568 3.919H78.58l1.343 1.4-1.791 2.854-2.35 3.694v49.706h-.505V29.881l-4.141-6.549.895-.951.392-.448h-1.791l.504-1.288 1.063-2.575h.784H66.378c-3.861 0-7.387 2.127-9.234 5.486l-4.87 9.068-13.88-1.623v3.638l10.69 4.59c3.022 1.288 6.548.504 8.787-1.959l2.575-2.91.84 45.227h28.32l.839-44.948 5.709 5.038a4.66 4.66 0 006.66-.504l8.619-10.243-2.575-3.415z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.64 13.704c-.616 1.176-1.008 2.519-1.008 3.974v.336h2.35V13.76h-.839c-.168 0-.336-.056-.504-.056zM82.273 9.674a6.361 6.361 0 00.672-2.91c0-3.64-2.966-6.55-6.548-6.55h-2.295a6.14 6.14 0 00-6.156 6.157l4.31-3.862c.447 2.24 2.462 3.862 4.756 3.862h.896c1.231 0 2.35.896 2.463 2.072 0 .28 0 .503-.056.727-.224 1.064-1.176 1.847-2.24 1.847v6.997h6.717c1.007 0 2.015.168 2.91.448 0-.28.056-.504.056-.784 0-3.638-2.294-6.773-5.485-8.004z",
    fill: "#2B435E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.37 8.442c-.111-1.231-1.23-2.07-2.462-2.07h-.896c-2.294 0-4.253-1.624-4.757-3.863l-4.31 3.862v3.135c0 2.127 1.624 3.918 3.695 4.142.167 0 .335.056.503.056h.84v4.254h5.037V10.961c1.12 0 2.015-.783 2.239-1.847.112-.168.112-.392.112-.672z",
    fill: "#F799A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.983 18.014l1.399 6.718.895 4.31.224 1.175.28-1.175.672-3.303 1.567-7.725h-5.037z",
    fill: "#31679E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.37 21.877l-1.567-3.863h-.783l-1.567 7.725-.672 3.303-.28 1.175-.224-1.175-.895-4.31-1.4-6.718H72.2l-1.007 2.575-.56 1.288h1.847l-.448.448-.895.951 4.141 6.55v49.761h.504V29.825l2.295-3.694 1.847-2.855-1.343-1.4h1.79z",
    fill: "#F3F3F4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.285 112.501h6.66v-4.702h-3.637l-3.75 2.071c-1.176.728-.672 2.631.727 2.631zM80.035 112.501h6.66v-4.702h-3.638l-3.75 2.071c-1.231.728-.728 2.631.728 2.631z",
    fill: "#2B435E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.509 6.54c-.616-.112-1.791-.336-4.254-.336-2.463 0-3.638.224-4.254.335-.615.112-.615.392-.671 1.008 0 .672.056 1.4.448 1.903.391.504 2.238.672 3.078.336.783-.336.727-1.567 1.399-1.567s.616 1.231 1.4 1.567c.783.336 2.686.168 3.078-.336.391-.504.447-1.231.447-1.903-.056-.56-.056-.896-.671-1.008z",
    fill: "#FAC2CA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.448 23.612l-3.079.952V22.66h3.079v.952z",
    fill: "#F799A7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.858 25.515l1.512-2.855h3.805l1.568 3.527-4.254 2.687-2.631-3.359z",
    fill: "#F799A7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1 35.367h-.112v-5.71l.56-1.007h-3.806l.56 1.008v5.709h-.113c-.951 0-1.847.504-2.35 1.231h7.667c-.56-.727-1.455-1.231-2.406-1.231z",
    fill: "#F7F7F0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.783 36.598c-.336.504-.56 1.064-.56 1.736a2.89 2.89 0 002.91 2.91h2.91a2.89 2.89 0 002.911-2.91c0-.616-.224-1.232-.56-1.736h-7.611z",
    fill: "#F0655F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 112.501V41.244h50.707v71.257h-.951V101.25H.95v11.251H0zm49.7-51.61V42.197H.895v18.696H49.7zm0 1.008v18.696H.895V61.899H49.7zM.95 81.603v18.695h48.805V81.603H.95z",
    fill: "#72A3CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.904 59.828h-4.141a1.65 1.65 0 01-1.68-1.68v-5.765h7.445v5.766c.055.951-.672 1.679-1.624 1.679zM85.24 59.828h-4.142a1.65 1.65 0 01-1.68-1.68v-5.765h7.445v5.766c.056.951-.728 1.679-1.623 1.679z",
    fill: "#F3F3F4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.671 100.298h-6.94a1.343 1.343 0 01-1.175-2.015l3.302-5.933H13.6l3.303 5.933c.447.896-.168 2.015-1.232 2.015z",
    fill: "#F0655F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.298 87.704l.56 1.063v3.527H13.6v-3.527l.56-1.063h-3.862z",
    fill: "#F7F7F0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.92 100.298h-6.94a1.343 1.343 0 01-1.175-2.015l3.302-5.933h2.743l3.302 5.933c.447.896-.224 2.015-1.232 2.015z",
    fill: "#2B435E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.548 87.704l.56 1.063v3.527h2.686v-3.527l.615-1.063h-3.861zM26.697 91.79v-3.023l.56-1.063h-3.862l.56 1.063v3.023a4.353 4.353 0 00-3.023 4.142h8.731c.056-1.959-1.231-3.582-2.966-4.142z",
    fill: "#F7F7F0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.354 100.298a4.371 4.371 0 004.365-4.366h-8.731a4.371 4.371 0 004.366 4.366z",
    fill: "#88BCD3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.204 72.702v6.55c0 .727.615 1.343 1.343 1.343h5.877c.727 0 1.343-.616 1.343-1.344v-6.549h-8.563z",
    fill: "#31679E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.644 68l.56 1.064v3.638h8.563v-4.701h-9.123z",
    fill: "#F7F7F0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M35.204 70.072h1.287v.224h-1.287zM35.204 71.751h1.287v.224h-1.287zM35.204 73.374h1.287v.224h-1.287zM35.204 75.053h1.287v.224h-1.287zM35.204 76.677h1.287v.224h-1.287zM35.204 78.3h1.287v.224h-1.287z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.45 30.945l-2.518-1.288v4.982l2.518-.056v-3.638zM34.868 34.64h-2.127v-3.303l2.127-1.12v4.422z",
    fill: "#F799A7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M112.44 29.657a.74.74 0 01-.727-.727v-6.605h1.455v6.605a.741.741 0 01-.728.727z",
    fill: "#88BCD3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.56 22.325h-2.295l.616-.672h1.063l.616.672z",
    fill: "#B3D5F5"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.44 30.665a.361.361 0 01-.336-.336v-1.511h.672v1.511c-.056.168-.168.336-.336.336z",
    fill: "#88BCD3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M111.657 23.164h.893v.224h-.893zM111.657 24.452h.893v.224h-.893zM111.657 25.739h.893v.224h-.893zM111.657 26.971h.893v.224h-.893zM111.657 28.258h.893v.224h-.893z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M111.881 21.653l-.448-1.735a.881.881 0 01.28-.952.98.98 0 011.399 0c.224.224.336.616.28.952l-.448 1.735h-1.063z",
    fill: "#B3D5F5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M64.308 107.799h3.637l3.079-28.212h-7.612l.896 28.212zM79.979 79.587l3.078 28.212h3.638l.951-28.212H79.98z",
    fill: "#5EB6FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEB",
    d: "M10.018 48.353h1.959v1.399h-1.959z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.018 49.753v8.172c0 .56.448.952.952.952.56 0 .951-.448.951-.952v-8.172h-1.903zM11.921 48.353h-1.903l-.392-.727h2.295v.727z",
    fill: "#F7F7F0"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M10.018 51.376h.893v.224h-.893zM10.018 52.551h.893v.224h-.893zM10.018 53.727h.893v.224h-.893zM10.018 49.081h.893v.224h-.893zM10.018 50.2h.893v.224h-.893zM10.018 54.902h.893v.224h-.893zM10.018 56.078h.893v.224h-.893zM10.018 57.253h.893v.224h-.893z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEB",
    d: "M14.887 48.353h1.959v6.661h-1.959z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.887 55.014v2.911c0 .56.448.952.952.952.56 0 .951-.448.951-.952v-2.91h-1.902z",
    fill: "#F0655F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79 48.353h-1.903l-.391-.727h2.294v.727z",
    fill: "#F7F7F0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M14.887 51.376h.893v.224h-.893zM14.887 52.551h.893v.224h-.893zM14.887 53.727h.893v.224h-.893z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F0",
    d: "M14.887 49.081h.893v.224h-.893z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M14.887 50.2h.893v.224h-.893zM14.887 54.902h.893v.224h-.893zM14.887 56.078h.893v.224h-.893zM14.887 57.253h.893v.224h-.893z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F0",
    d: "M19.757 48.353h1.959v3.135h-1.959z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M19.757 51.488v6.381c0 .56.448.952.951.952.56 0 .952-.448.952-.952v-6.381h-1.903z",
    fill: "#DEDED8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.716 48.353h-1.96l-.391-.727h2.35v.727z",
    fill: "#EEEEEB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M19.757 51.376h.893v.224h-.893zM19.757 52.551h.893v.224h-.893zM19.757 53.727h.893v.224h-.893zM19.757 49.081h.893v.224h-.893zM19.757 50.2h.893v.224h-.893z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#88BCD3",
    d: "M19.757 54.902h.893v.224h-.893z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M19.757 56.078h.893v.224h-.893zM19.757 57.253h.893v.224h-.893z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEEEEB",
    d: "M24.626 48.353h1.959v1.399h-1.959z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.626 49.753v8.172c0 .56.448.952.951.952a.98.98 0 00.952-.952v-8.172h-1.903zM26.585 48.353h-1.96l-.39-.727h2.35v.727z",
    fill: "#F7F7F0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M24.626 51.376h.893v.224h-.893zM24.626 52.551h.893v.224h-.893zM24.626 53.727h.893v.224h-.893zM24.626 49.081h.893v.224h-.893zM24.626 50.2h.893v.224h-.893zM24.626 54.902h.893v.224h-.893zM24.626 56.078h.893v.224h-.893zM24.626 57.253h.893v.224h-.893zM7.723 58.877h20.764v2.015H7.723z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M7.612 46.506h.224v14.442h-.224zM28.376 46.506h.224v14.442h-.224z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B435E",
    d: "M7.723 51.376h20.764v.224H7.723z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#70B9CA",
    d: "M14.104 79.14h13.209v1.455H14.104z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#31679E",
    d: "M11.473 77.74h13.209v1.455H11.473z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0655F",
    d: "M14.104 76.285h13.209v1.455H14.104z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.658 91.086a3.963 3.963 0 010-5.593 3.96 3.96 0 015.592 0c1.54 1.54 2.411 8.004 2.411 8.004s-6.429-.87-8.003-2.411zM112.658 101.963a3.963 3.963 0 010-5.593 3.96 3.96 0 015.592 0c1.54 1.54 2.411 8.004 2.411 8.004s-6.463-.87-8.003-2.411zM112.658 112.84a3.963 3.963 0 010-5.593 3.96 3.96 0 015.592 0c1.54 1.541 2.411 8.004 2.411 8.004s-6.463-.871-8.003-2.411z",
    fill: "#31679E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-searcharea-people2_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 89,
    width: 11,
    height: 11
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.887 89.611h9.47v9.506h-9.47v-9.506z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home-searcharea-people2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.158 96.615a4.11 4.11 0 000-5.804 4.11 4.11 0 00-5.804 0c-1.598 1.598-2.467 8.306-2.467 8.306s6.673-.903 8.271-2.502z",
    fill: "#31679E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "home-searcharea-people2_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 100,
    width: 11,
    height: 10
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.887 100.454h9.47v9.506h-9.47v-9.506z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home-searcharea-people2_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.158 107.457a4.11 4.11 0 000-5.804 4.11 4.11 0 00-5.804 0c-1.598 1.599-2.467 8.307-2.467 8.307s6.673-.904 8.271-2.503z",
    fill: "#31679E"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.272 116.969c-1.552 1.85-2.194 4.363-1.789 6.771l1.789 10.403h9.35l1.789-10.403a8.446 8.446 0 00-1.789-6.771h-9.35z",
    fill: "#2B435E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "home-searcharea-people2_svg__c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 73,
    width: 10,
    height: 13
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.912 73.666h8.105v11.576h-8.105V73.666z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#home-searcharea-people2_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.912 77.72a4.06 4.06 0 014.052-4.054 4.06 4.06 0 014.053 4.053c0 2.233-4.053 7.523-4.053 7.523s-4.052-5.29-4.052-7.523z",
    fill: "#31679E"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.343 105.017l-4.06 4.18-.034-10.017 4.564-4.663-.47-.518-4.094 4.213V78.04h-.671v14.577l-4.026-4.11-.47.483 4.496 4.628v10.052l-4.026-4.145-.47.484 4.496 4.628.034 10.052-4.06-4.145-.47.483 4.53 4.629v1.313h.671v-6.771l4.53-4.697-.47-.484z",
    fill: "#2B435E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCenterImage);
export default __webpack_public_path__ + "static/media/centerImage.2e05803de9df6864b3366c30e0a37275.svg";
export { ForwardRef as ReactComponent };